import AccountDeleteView from './AccountDeleteView';

export default AccountDeleteView;
